import React from 'react';
import { SIDE_MENU_URL_LOGO } from '../SideNavigationMenu/SideNavigationMenuConfiguration';
import { SgLogo } from '../../../components/SgLogo/SgLogo';

export type LogoProps = {
    isCollapsible: boolean;
    handleOpenSendboardLeaveModal: (route: string) => void;
    logoUrl: string;
};

export const Logo = ({ isCollapsible, handleOpenSendboardLeaveModal, logoUrl }: LogoProps) => (
    <SgLogo
        data-signa="sidebar-expanded-logo"
        isCollapsible={isCollapsible}
        href={SIDE_MENU_URL_LOGO.HREF}
        src={logoUrl}
        onClick={() => handleOpenSendboardLeaveModal(SIDE_MENU_URL_LOGO.HREF)}
    />
);
